<template>
    <div>
        <div >
            <div class="slider">
                <img :src="activeImage" transition="fade" class="img-responsive"/>
                <div class="slider-controls" v-show="images.length > 1">
                    <img class="prev-slide" @click="step(-1)" src="/static/prev.png" alt="">
                    <img class="next-slide" @click="step(1)" src="/static/next.png" alt="">
                    <button v-show="images.length > 1" @click="step(1)" class="prev-button btn btn-default">{{ previousButton }}</button>
                    <button v-show="images.length > 1" @click="step(-1)" class="next-button btn btn-default">{{ nextButton }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'default',
      'images',
      'nextButton',
      'previousButton',
    ],

    data () {
      return {
        activeIndex: null
      };
    },

    computed: {
      activeImage () {
        let index = this.activeIndex !== null ? this.activeIndex : this.default;
        return this.images[Math.abs(index) % this.images.length];
      }
    },

    methods: {
      step (num) {
        this.activeIndex += num;
      }
    }
  };
</script>

<style scoped>

  img {
    max-height: 550px;
    max-width: 100%;
  }

    .btn {
        margin: 0px 5px;
    }

  .slider{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    /* padding: 10px; */
  }

  .slider-controls{
    margin-top: 1.5%;
    display: flex;
  }

  .prev-slide{
    margin-right: 50px;
  }

  .next-slide{
    margin-left: 50px;
  }

  .prev-button, .next-button{
    display: none;
  }

  @media screen and (max-width: 767px) {
    .next-slide, .prev-slide{
      display: none;
    }

    .prev-button, .next-button{
      display: block;
    }

    .prev-button{
      margin-right: 50px;
    }

    .next-button{
      margin-left: 50px;
    }

  }

</style>



// WEBPACK FOOTER //
// BasicSlider.vue?3a771a58